import type { EvalResolutionCheck, EvalRunSummary } from '@queries/evalRuns';

import { RUN_IS_TERMINAL } from '../types';

/**
 * Why "Re-run guidance scan" is off, or `undefined` when it can go ahead.
 *
 * Re-running means asking the AI re-check which suggestions the contract's
 * edits have since resolved (reviewed ones included — they get a second
 * opinion, not a reopen), so it needs a completed scan, a persisted contract
 * snapshot to diff against (runs from before the snapshot step have none) and
 * at least one suggestion to judge. Whether the contract actually changed is
 * a server guard — its message comes back as a toast.
 */
export const describeRerunBlock = (
  run: EvalRunSummary,
  latestCheck: EvalResolutionCheck | undefined,
  assessableFindingCount: number,
): string | undefined => {
  if (latestCheck && !RUN_IS_TERMINAL[latestCheck.status]) return 'A re-check is already running.';
  if (run.status !== 'SUCCEEDED') return 'Re-checks need a completed scan.';
  if (!run.contract_snapshot_key) return 'This scan predates re-checks — run a new scan instead.';
  if (assessableFindingCount === 0) return 'This scan raised no suggestions — nothing to re-check.';
  return undefined;
};
